/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FaceScanBaseService } from '../face-scan-base-service';
import { FaceScanApiConfiguration } from '../face-scan-api-configuration';
import { FaceScanStrictHttpResponse } from '../face-scan-strict-http-response';

import { AccessCodeModel } from '../models/access-code-model';
import { ProfileResponseModel } from '../models/profile-response-model';
import { SdkConfigModel } from '../models/sdk-config-model';
import { sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet } from '../fn/session/session-access-code-config-get-system-identifier-id-access-code-get';
import { SessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Params } from '../fn/session/session-access-code-config-get-system-identifier-id-access-code-get';
import { sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost } from '../fn/session/session-access-code-identifier-allowed-system-identifier-id-access-code-post';
import { SessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Params } from '../fn/session/session-access-code-identifier-allowed-system-identifier-id-access-code-post';
import { sessionAccessTokenPost } from '../fn/session/session-access-token-post';
import { SessionAccessTokenPost$Params } from '../fn/session/session-access-token-post';
import { sessionHistorySystemIdentifierIdGet } from '../fn/session/session-history-system-identifier-id-get';
import { SessionHistorySystemIdentifierIdGet$Params } from '../fn/session/session-history-system-identifier-id-get';
import { sessionMemberLastScanGetSystemIdentifierIdGet } from '../fn/session/session-member-last-scan-get-system-identifier-id-get';
import { SessionMemberLastScanGetSystemIdentifierIdGet$Params } from '../fn/session/session-member-last-scan-get-system-identifier-id-get';
import { sessionRequestSessionPost } from '../fn/session/session-request-session-post';
import { SessionRequestSessionPost$Params } from '../fn/session/session-request-session-post';
import { SessionResponseModel } from '../models/session-response-model';
import { SessionResultModel } from '../models/session-result-model';
import { sessionScanCompletedSessionIdGet } from '../fn/session/session-scan-completed-session-id-get';
import { SessionScanCompletedSessionIdGet$Params } from '../fn/session/session-scan-completed-session-id-get';
import { sessionSdkCompletedPost } from '../fn/session/session-sdk-completed-post';
import { SessionSdkCompletedPost$Params } from '../fn/session/session-sdk-completed-post';
import { sessionSdkConfigGet } from '../fn/session/session-sdk-config-get';
import { SessionSdkConfigGet$Params } from '../fn/session/session-sdk-config-get';
import { sessionSdkErrorPost } from '../fn/session/session-sdk-error-post';
import { SessionSdkErrorPost$Params } from '../fn/session/session-sdk-error-post';
import { sessionSdkMessageLogPost } from '../fn/session/session-sdk-message-log-post';
import { SessionSdkMessageLogPost$Params } from '../fn/session/session-sdk-message-log-post';
import { sessionSdkScanConfigAsyncPost } from '../fn/session/session-sdk-scan-config-async-post';
import { SessionSdkScanConfigAsyncPost$Params } from '../fn/session/session-sdk-scan-config-async-post';
import { sessionSessionHistorySystemIdentifierIdProfileIdGet } from '../fn/session/session-session-history-system-identifier-id-profile-id-get';
import { SessionSessionHistorySystemIdentifierIdProfileIdGet$Params } from '../fn/session/session-session-history-system-identifier-id-profile-id-get';
import { sessionSessionProfileSystemIdentifierIdProfileIdGet } from '../fn/session/session-session-profile-system-identifier-id-profile-id-get';
import { SessionSessionProfileSystemIdentifierIdProfileIdGet$Params } from '../fn/session/session-session-profile-system-identifier-id-profile-id-get';
import { sessionSessionResultSessionIdGet } from '../fn/session/session-session-result-session-id-get';
import { SessionSessionResultSessionIdGet$Params } from '../fn/session/session-session-result-session-id-get';
import { sessionSubmitSdkSessionPost } from '../fn/session/session-submit-sdk-session-post';
import { SessionSubmitSdkSessionPost$Params } from '../fn/session/session-submit-sdk-session-post';
import { sessionSubmitWebSdkEventPost } from '../fn/session/session-submit-web-sdk-event-post';
import { SessionSubmitWebSdkEventPost$Params } from '../fn/session/session-submit-web-sdk-event-post';
import { sessionSubmitWebSdkSessionPost } from '../fn/session/session-submit-web-sdk-session-post';
import { SessionSubmitWebSdkSessionPost$Params } from '../fn/session/session-submit-web-sdk-session-post';
import { sessionValidateScanAllowedSessionIdGet } from '../fn/session/session-validate-scan-allowed-session-id-get';
import { SessionValidateScanAllowedSessionIdGet$Params } from '../fn/session/session-validate-scan-allowed-session-id-get';
import { TokenResponseModel } from '../models/token-response-model';

@Injectable({ providedIn: 'root' })
export class FaceScanSessionService extends FaceScanBaseService {
  constructor(config: FaceScanApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sessionRequestSessionPost()` */
  static readonly SessionRequestSessionPostPath = '/Session/RequestSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionRequestSessionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionRequestSessionPost$Response(params?: SessionRequestSessionPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SessionResponseModel>> {
    return sessionRequestSessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionRequestSessionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionRequestSessionPost(params?: SessionRequestSessionPost$Params, context?: HttpContext): Observable<SessionResponseModel> {
    return this.sessionRequestSessionPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SessionResponseModel>): SessionResponseModel => r.body)
    );
  }

  /** Path part for operation `sessionValidateScanAllowedSessionIdGet()` */
  static readonly SessionValidateScanAllowedSessionIdGetPath = '/Session/ValidateScanAllowed/{sessionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionValidateScanAllowedSessionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionValidateScanAllowedSessionIdGet$Response(params: SessionValidateScanAllowedSessionIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<ProfileResponseModel>> {
    return sessionValidateScanAllowedSessionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionValidateScanAllowedSessionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionValidateScanAllowedSessionIdGet(params: SessionValidateScanAllowedSessionIdGet$Params, context?: HttpContext): Observable<ProfileResponseModel> {
    return this.sessionValidateScanAllowedSessionIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<ProfileResponseModel>): ProfileResponseModel => r.body)
    );
  }

  /** Path part for operation `sessionSubmitWebSdkSessionPost()` */
  static readonly SessionSubmitWebSdkSessionPostPath = '/Session/SubmitWebSDKSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSubmitWebSdkSessionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSubmitWebSdkSessionPost$Response(params?: SessionSubmitWebSdkSessionPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<void>> {
    return sessionSubmitWebSdkSessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSubmitWebSdkSessionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSubmitWebSdkSessionPost(params?: SessionSubmitWebSdkSessionPost$Params, context?: HttpContext): Observable<void> {
    return this.sessionSubmitWebSdkSessionPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sessionSubmitWebSdkEventPost()` */
  static readonly SessionSubmitWebSdkEventPostPath = '/Session/SubmitWebSDKEvent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSubmitWebSdkEventPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSubmitWebSdkEventPost$Response(params?: SessionSubmitWebSdkEventPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<void>> {
    return sessionSubmitWebSdkEventPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSubmitWebSdkEventPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSubmitWebSdkEventPost(params?: SessionSubmitWebSdkEventPost$Params, context?: HttpContext): Observable<void> {
    return this.sessionSubmitWebSdkEventPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sessionSessionProfileSystemIdentifierIdProfileIdGet()` */
  static readonly SessionSessionProfileSystemIdentifierIdProfileIdGetPath = '/Session/SessionProfile/{systemIdentifierId}/{profileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSessionProfileSystemIdentifierIdProfileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSessionProfileSystemIdentifierIdProfileIdGet$Response(params: SessionSessionProfileSystemIdentifierIdProfileIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<ProfileResponseModel>> {
    return sessionSessionProfileSystemIdentifierIdProfileIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSessionProfileSystemIdentifierIdProfileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSessionProfileSystemIdentifierIdProfileIdGet(params: SessionSessionProfileSystemIdentifierIdProfileIdGet$Params, context?: HttpContext): Observable<ProfileResponseModel> {
    return this.sessionSessionProfileSystemIdentifierIdProfileIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<ProfileResponseModel>): ProfileResponseModel => r.body)
    );
  }

  /** Path part for operation `sessionSessionResultSessionIdGet()` */
  static readonly SessionSessionResultSessionIdGetPath = '/Session/SessionResult/{sessionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSessionResultSessionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSessionResultSessionIdGet$Response(params: SessionSessionResultSessionIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SessionResultModel>> {
    return sessionSessionResultSessionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSessionResultSessionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSessionResultSessionIdGet(params: SessionSessionResultSessionIdGet$Params, context?: HttpContext): Observable<SessionResultModel> {
    return this.sessionSessionResultSessionIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SessionResultModel>): SessionResultModel => r.body)
    );
  }

  /** Path part for operation `sessionSessionHistorySystemIdentifierIdProfileIdGet()` */
  static readonly SessionSessionHistorySystemIdentifierIdProfileIdGetPath = '/Session/SessionHistory/{systemIdentifierId}/{profileId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSessionHistorySystemIdentifierIdProfileIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSessionHistorySystemIdentifierIdProfileIdGet$Response(params: SessionSessionHistorySystemIdentifierIdProfileIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<Array<SessionResultModel>>> {
    return sessionSessionHistorySystemIdentifierIdProfileIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSessionHistorySystemIdentifierIdProfileIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSessionHistorySystemIdentifierIdProfileIdGet(params: SessionSessionHistorySystemIdentifierIdProfileIdGet$Params, context?: HttpContext): Observable<Array<SessionResultModel>> {
    return this.sessionSessionHistorySystemIdentifierIdProfileIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<Array<SessionResultModel>>): Array<SessionResultModel> => r.body)
    );
  }

  /** Path part for operation `sessionHistorySystemIdentifierIdGet()` */
  static readonly SessionHistorySystemIdentifierIdGetPath = '/Session/History/{systemIdentifierId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionHistorySystemIdentifierIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionHistorySystemIdentifierIdGet$Response(params: SessionHistorySystemIdentifierIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<Array<SessionResultModel>>> {
    return sessionHistorySystemIdentifierIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionHistorySystemIdentifierIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionHistorySystemIdentifierIdGet(params: SessionHistorySystemIdentifierIdGet$Params, context?: HttpContext): Observable<Array<SessionResultModel>> {
    return this.sessionHistorySystemIdentifierIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<Array<SessionResultModel>>): Array<SessionResultModel> => r.body)
    );
  }

  /** Path part for operation `sessionAccessTokenPost()` */
  static readonly SessionAccessTokenPostPath = '/Session/AccessToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionAccessTokenPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionAccessTokenPost$Response(params?: SessionAccessTokenPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<TokenResponseModel>> {
    return sessionAccessTokenPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionAccessTokenPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionAccessTokenPost(params?: SessionAccessTokenPost$Params, context?: HttpContext): Observable<TokenResponseModel> {
    return this.sessionAccessTokenPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<TokenResponseModel>): TokenResponseModel => r.body)
    );
  }

  /** Path part for operation `sessionSubmitSdkSessionPost()` */
  static readonly SessionSubmitSdkSessionPostPath = '/Session/SubmitSDKSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSubmitSdkSessionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSubmitSdkSessionPost$Response(params?: SessionSubmitSdkSessionPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SessionResultModel>> {
    return sessionSubmitSdkSessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSubmitSdkSessionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSubmitSdkSessionPost(params?: SessionSubmitSdkSessionPost$Params, context?: HttpContext): Observable<SessionResultModel> {
    return this.sessionSubmitSdkSessionPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SessionResultModel>): SessionResultModel => r.body)
    );
  }

  /** Path part for operation `sessionScanCompletedSessionIdGet()` */
  static readonly SessionScanCompletedSessionIdGetPath = '/Session/ScanCompleted/{sessionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionScanCompletedSessionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionScanCompletedSessionIdGet$Response(params: SessionScanCompletedSessionIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<boolean>> {
    return sessionScanCompletedSessionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionScanCompletedSessionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionScanCompletedSessionIdGet(params: SessionScanCompletedSessionIdGet$Params, context?: HttpContext): Observable<boolean> {
    return this.sessionScanCompletedSessionIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `sessionSdkScanConfigAsyncPost()` */
  static readonly SessionSdkScanConfigAsyncPostPath = '/Session/SDKScanConfigAsync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSdkScanConfigAsyncPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkScanConfigAsyncPost$Response(params?: SessionSdkScanConfigAsyncPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SdkConfigModel>> {
    return sessionSdkScanConfigAsyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSdkScanConfigAsyncPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkScanConfigAsyncPost(params?: SessionSdkScanConfigAsyncPost$Params, context?: HttpContext): Observable<SdkConfigModel> {
    return this.sessionSdkScanConfigAsyncPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SdkConfigModel>): SdkConfigModel => r.body)
    );
  }

  /** Path part for operation `sessionSdkConfigGet()` */
  static readonly SessionSdkConfigGetPath = '/Session/SDKConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSdkConfigGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSdkConfigGet$Response(params?: SessionSdkConfigGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SdkConfigModel>> {
    return sessionSdkConfigGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSdkConfigGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionSdkConfigGet(params?: SessionSdkConfigGet$Params, context?: HttpContext): Observable<SdkConfigModel> {
    return this.sessionSdkConfigGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SdkConfigModel>): SdkConfigModel => r.body)
    );
  }

  /** Path part for operation `sessionMemberLastScanGetSystemIdentifierIdGet()` */
  static readonly SessionMemberLastScanGetSystemIdentifierIdGetPath = '/Session/MemberLastScanGet/{systemIdentifierId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionMemberLastScanGetSystemIdentifierIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionMemberLastScanGetSystemIdentifierIdGet$Response(params: SessionMemberLastScanGetSystemIdentifierIdGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SessionResultModel>> {
    return sessionMemberLastScanGetSystemIdentifierIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionMemberLastScanGetSystemIdentifierIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionMemberLastScanGetSystemIdentifierIdGet(params: SessionMemberLastScanGetSystemIdentifierIdGet$Params, context?: HttpContext): Observable<SessionResultModel> {
    return this.sessionMemberLastScanGetSystemIdentifierIdGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SessionResultModel>): SessionResultModel => r.body)
    );
  }

  /** Path part for operation `sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet()` */
  static readonly SessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGetPath = '/Session/AccessCodeConfigGet/{systemIdentifierId}/{accessCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Response(params: SessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<AccessCodeModel>> {
    return sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet(params: SessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Params, context?: HttpContext): Observable<AccessCodeModel> {
    return this.sessionAccessCodeConfigGetSystemIdentifierIdAccessCodeGet$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<AccessCodeModel>): AccessCodeModel => r.body)
    );
  }

  /** Path part for operation `sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost()` */
  static readonly SessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePostPath = '/Session/AccessCodeIdentifierAllowed/{systemIdentifierId}/{accessCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Response(params: SessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<AccessCodeModel>> {
    return sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost(params: SessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Params, context?: HttpContext): Observable<AccessCodeModel> {
    return this.sessionAccessCodeIdentifierAllowedSystemIdentifierIdAccessCodePost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<AccessCodeModel>): AccessCodeModel => r.body)
    );
  }

  /** Path part for operation `sessionSdkCompletedPost()` */
  static readonly SessionSdkCompletedPostPath = '/Session/SDKCompleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSdkCompletedPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkCompletedPost$Response(params?: SessionSdkCompletedPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SessionResultModel>> {
    return sessionSdkCompletedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSdkCompletedPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkCompletedPost(params?: SessionSdkCompletedPost$Params, context?: HttpContext): Observable<SessionResultModel> {
    return this.sessionSdkCompletedPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<SessionResultModel>): SessionResultModel => r.body)
    );
  }

  /** Path part for operation `sessionSdkMessageLogPost()` */
  static readonly SessionSdkMessageLogPostPath = '/Session/SDKMessageLog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSdkMessageLogPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkMessageLogPost$Response(params?: SessionSdkMessageLogPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<void>> {
    return sessionSdkMessageLogPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSdkMessageLogPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkMessageLogPost(params?: SessionSdkMessageLogPost$Params, context?: HttpContext): Observable<void> {
    return this.sessionSdkMessageLogPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sessionSdkErrorPost()` */
  static readonly SessionSdkErrorPostPath = '/Session/SDKError';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sessionSdkErrorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkErrorPost$Response(params?: SessionSdkErrorPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<void>> {
    return sessionSdkErrorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sessionSdkErrorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sessionSdkErrorPost(params?: SessionSdkErrorPost$Params, context?: HttpContext): Observable<void> {
    return this.sessionSdkErrorPost$Response(params, context).pipe(
      map((r: FaceScanStrictHttpResponse<void>): void => r.body)
    );
  }

}
